import { isEmpty } from 'lodash';
import coordinationCenterNetwork from './coordinationCenterNetwork';

export default function isCoordinationCenter(networks = [], groupId = '') {
  return !isEmpty(coordinationCenterNetwork(networks, groupId));
}
